<template>
  <div class="upload-file">
    <div class="upload-block" v-if="type == 1">
      <div class="title">
        <p>拍摄/上传您的证件照</p>
        <p>并底衬A4纸附监护人/本人（16岁以上）签名</p>
      </div>
      <div class="uploader-id">
        <img v-if="certificateFrontImg" :src="certificateFrontImg" alt="">
        <img v-if="!certificateFrontImg" src="@/assets/images/id-front.png">
        <div class="upload-loading" v-show="certificateFrontLod" >
          <van-loading type="spinner" />
        </div>
        <van-uploader v-show="!certificateFrontLod" :disabled="isRead" :after-read="onReadPositive" class="uploaderBnt">
          <!--<van-icon name="photograph"/>-->
          <div v-show="!isRead">
            <img src="@/assets/images/carmera.png" >
            <b>点击拍摄/上传人像面+签名</b>
          </div>
        </van-uploader>
        <div style="" ></div>
      </div>
      <div style="width: 100%; height: 20px;" ></div>
      <div class="uploader-id">
        <img v-if="certificateBackImg" :src="certificateBackImg" alt="">
        <img v-if="!certificateBackImg" src="@/assets/images/id-back.png">
        <div class="upload-loading" v-show="certificateBackLod" >
          <van-loading type="spinner" />
        </div>
        <van-uploader v-show="!certificateBackLod" :disabled="isRead" :after-read="onReadNegative" class="uploaderBnt">
          <div v-show="!isRead">
            <img src="@/assets/images/carmera.png" >
            <b>点击拍摄/上传国徽面+签名</b>
          </div>
        </van-uploader>
      </div>
    </div>
    <div class="upload-block" v-if="type == 2">
      <div class="title" style="padding-bottom: 15px">拍摄/上传您的学籍卡</div>
      <div class="title" style="padding-top: 0;color: red;">注：北京学生需要提交学籍卡信息（或者北京通，新生可以上传录取通知书）</div>
      <div class="uploader-id">
        <img v-if="studentCardImg" :src="studentCardImg" alt="">
        <img v-if="!studentCardImg" src="@/assets/images/passport.png">
        <div class="upload-loading" v-show="studentCardLod" >
          <van-loading type="spinner" />
        </div>
        <van-uploader v-show="!studentCardLod" :after-read="onReadStudentID" class="uploaderBnt">
          <div v-show="!studentCardLod">
            <img src="@/assets/images/carmera.png" >
            <b>点击拍摄/上传学籍卡</b>
          </div>
        </van-uploader>
      </div>
    </div>
    <div class="upload-block" v-if="type == 3">
      <div class="title">拍摄/上传您的资质证明</div>
      <div class="uploader-id cert">
        <img v-if="certificateImg" :src="certificateImg" alt="">
        <img v-if="!certificateImg" src="@/assets/images/passport.png">
        <div class="upload-loading" v-show="certificateLod" >
          <van-loading type="spinner" />
        </div>
        <van-uploader v-show="!certificateLod" :disabled="isClubRead" :after-read="onReadCert" class="uploaderBnt">
          <div v-show="!isClubRead">
            <img src="@/assets/images/carmera.png" >
            <b>点击拍摄/上传资质证明+签名</b>
          </div>
        </van-uploader>
      </div>
    </div>
    <van-button size="large" class="btn" @click="certDone()">完成</van-button>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import { checkPassport } from '@/libs/passport'
import { ImageFormat, ConstConfig, getValidMembership } from '@/utils'
import { getQiniuUploadToken } from '@/api/user'
import { updatePlayer } from '@/api/info'
import { setRegisterInfo, getRegisterInfo, getMemberType } from '@/libs/cookie-storage'

import { Uploader, Button, Toast, Loading } from 'vant'

Vue.use(Uploader, Button).use(Toast).use(Loading)

export default {
  name: 'IDrard',
  data() {
    return {
      isRead: false,
      isClubRead: false,
      isAppend: false,
      qiniuToken: '',
      type: '',
      accept: 'image/jpeg,image/gif,image/png,image/bmp',
      info: {
        certificateFrontImg: '',
        certificateBackImg: '',
        studentCardImg: '',
        certificateImg: ''
      },
      certificateFrontLod: false,
      certificateBackLod: false,
      studentCardLod: false,
      certificateLod: false,
      reset: '',
      memberType: {}
    }
  },
  computed: {
    // => 做法有误请勿模仿, 只是为了短暂的实现交互效果而迫不得已
    certificateFrontImg() {
      return ImageFormat.squareImageView(this.info.certificateFrontImg, 0, 0)
    },
    certificateBackImg() {
      return ImageFormat.squareImageView(this.info.certificateBackImg, 0, 0)
    },
    studentCardImg() {
      return ImageFormat.squareImageView(this.info.studentCardImg, 0, 0)
    },
    certificateImg() {
      return ImageFormat.squareImageView(this.info.certificateImg, 0, 0)
    }
  },
  created() {
    checkPassport()
    debugger
    this.reset = this.$route.query.reset
    // 初始化先尝试获取本地存储
    const memberType = this.memberType = getMemberType()
    if (!memberType) return
    if (memberType.status === 2 && memberType.paymentStatus > 0) {
      this.isRead = true
    }
    if (memberType.status === 2 && memberType.reset != 1) {
      this.isClubRead = true
    }
    const regInfo = getRegisterInfo()
    if(regInfo) {
      this.info = regInfo
    }
    this.type = this.$route.query && this.$route.query.type
    this.validMemberShip = getValidMembership()
    if(this.validMemberShip.membership && this.validMemberShip.membership.length > 0) {
      const obj = _.find(this.validMemberShip.membership, function (item) {
        return item.membershipTypeId === memberType.membershipTypeId
      })
      this.isAppend = !obj
      if (this.isAppend) {
        this.isRead = true
      }
    }
  },
  mounted() {
    this.getQiniuToken()
  },
  methods: {
    storeInfo() {
      const regInfo = Object.assign(getRegisterInfo(), this.info)
      setRegisterInfo(regInfo)
    },
    certDone() {
      if (this.memberType.status === 2 && this.memberType.membershipTypeId === 1) {
         this.updatePlayer()
      } else {
        const isCenter = this.$route.query.isCenter
        if (isCenter) {
          this.$router.push({ path: 'info', query: {isCenter: '1'} })
        } else {
          this.$router.push({ path: 'info', query: {reset: this.reset} })
        }
      }
    },
    onRead(file) {
    },
    uploadFile(file) {
      let formData = new FormData()
      formData.append('token', this.qiniuToken)
      formData.append('file', file.file)
      let config = {
        headers: {'Content-Type': 'multipart/form-data'}
      }
      return new Promise((resolve, reject) => {
        axios.post(ConstConfig.qiniuUpload, formData, config).then(res => {
          const data = res.data
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    getQiniuToken() {
      getQiniuUploadToken().then(response => {
        const data = response.data
        this.qiniuToken = data.token
      }).catch(err => {
        Toast('七牛Token获取失败')
      })
    },
    onReadNegative(file) {
      this.certificateBackLod = true
      this.uploadFile(file).then(res => {
        if (res) {
          this.info.certificateBackImg = res.hash
          this.storeInfo()
          this.certificateBackLod = false
        }
      })
    },
    onReadPositive(file) {
      this.certificateFrontLod = true
      this.uploadFile(file).then(res => {
        if (res) {
          this.info.certificateFrontImg = res.hash
          this.storeInfo()
          this.certificateFrontLod = false
        }
      })
    },
    onReadStudentID(file) {
      this.studentCardLod = true
      this.uploadFile(file).then(res => {
        if (res) {
          this.info.studentCardImg = res.hash
          this.storeInfo()
          this.studentCardLod = false
        }
      })
    },
    uploadFileOverSize(file) {
      Toast('文件过大')
    },
    onReadCert(file) {
      this.certificateLod = true
      this.uploadFile(file).then(res => {
        if (res) {
          this.info.certificateImg = res.hash
          this.storeInfo()
          this.certificateLod = false
        }
      })
    },
    updatePlayer() {
      const params = {
        id: this.info.id,
        profile: this.info.profile,
        stickHand: this.info.stickHand,
        high: this.info.high,
        weight: this.info.weight,
        category: this.info.category,
        schoolId: this.info.school.id,
        studentCardImg: this.info.studentCardImg,
        educationSummary: this.info.educationSummary
      }
      updatePlayer(params).then(response => {
        const data = response.data
        if (data) {
          this.$router.push({ path: 'info', query: {reset: this.reset} })
        }
      })
    },
  }
}
</script>

<style scoped>

.upload-file {
  height: 100%;
  background-color: #F8F8F8;
  padding: 0 15px;
  overflow-y: scroll;
}

.upload-block {
  background-color: #F8F8F8;
}

.upload-file .title {
  text-align: center;
  padding: 30px 0;
}

.upload-file .title p {
  font-size:14px;
  font-weight:400;
  color: red;
  line-height:20px;
  margin: 0;
}

.upload-file .uploader-id {
  text-align: center;
  position: relative;
}

.upload-file .uploader-id img {
  width: 100%;
}

.upload-file .uploader-id h4 {
  height: 40px;
  line-height: 40px;
  font-size: 14px;
  margin: 0;
}

.upload-file .btn {
  margin-top: 10px;
}

.upload-file .uploaderBnt {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 100;
}

.upload-file .uploaderBnt i {
  font-size: 45px;
}

.upload-file .uploaderBnt img {
  width: 50px;
  height: 50px;
}

.upload-file .uploaderBnt img+b {
  display: block;
  font-weight:600;
  color:rgba(24,84,148,1);
  line-height:20px;
  font-size:14px;
}

.upload-file .btn {
  height:60px;
  background:#185494;
  border-radius:2px;
  border: none;
  margin-top: 40px;
  font-weight:400;
  color: white;
  font-size:20px;
}

.upload-loading {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background-color: white;
}

.upload-loading .van-loading {
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
</style>



// WEBPACK FOOTER //
// src/pages/auth/upload-file.vue